import React, { useState, useContext } from 'react';
import { navigate } from 'hookrouter';

// import { useOktaAuth } from '@okta/okta-react';

//Context API for User Info
import { InfoContext } from "./../context/InfoContext";

//react-bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

//images
import gmr_logo_light from './../assets/gmr_logo_light.png';


const MainNavbar = () => {
    //current user Info
    const { info, setInfo } = useContext(InfoContext);

    // const { authState, authService } = useOktaAuth();

    // const login = async () => authService.login('/');
    // const logout = async () => authService.logout('/');
    const signOut = () => {
    setInfo(null);
    navigate('/');
    }

    return (
        <div className="header">
            <Container className="navBodyMain" fluid>
                <Row>
                    { info !== null && <Col className="paddingSmall navBodyUserInfo textAlignStart">
                        Signed in as: <a className="activeLinkLight" href="#login">{info.fullName}</a>
                    </Col> }
                    <Col className="paddingSmall textAlignCenter">
                        <img src={gmr_logo_light} className="App-logo"  />
                    </Col>
                    <Col className="paddingSmall navBodyButtons textAlignEnd">
                        <Button variant="outline-light" onClick={()=>signOut()}>Sign Out</Button>{' '}
                    </Col>
                </Row>
            </Container>

        </div>    
    );
};
export default MainNavbar;

